import { useNavigate, useParams } from 'react-router-dom'

import { useEffect } from 'react'

import { useFetchOrder } from './useFetchOrder'
import { useOrderMutations } from './useOrderMutations'

export const useOrderDetail = () => {
  const { id } = useParams()
  const navigate = useNavigate()

  const { order, isLoading: fetching, fetchOrder, setOrder } = useFetchOrder()

  const {
    loading: mutating,
    updateStatus,
    updateDiscount,
    updateCustomerInfo,
    updateAddress,
    addItem,
    updateItemDiscount,
    updateItemQuantity,
    removeItem,
    addCoupon,
    removeCoupon,
  } = useOrderMutations()

  useEffect(() => {
    if (id) {
      fetchOrder(id)
    }
  }, [id, fetchOrder])

  const refresh = () => {
    if (id) fetchOrder(id)
  }

  const wrapMutation = <T extends any[]>(fn: (...args: T) => Promise<any>) => {
    return async (...args: T) => {
      const result = await fn(...args)
      if (result) {
        setOrder(result)
      } else {
        refresh()
      }
      return result
    }
  }

  return {
    id,
    order,
    loading: fetching || mutating,
    refresh,
    navigate,
    actions: {
      updateStatus: wrapMutation((status: string) => updateStatus(id!, status)),
      updateDiscount: wrapMutation((discount: number) => updateDiscount(id!, discount)),
      updateCustomerInfo: wrapMutation((info: any) => updateCustomerInfo(id!, info)),
      updateAddress: wrapMutation((addressId: string) => updateAddress(id!, addressId)),
      addItem: wrapMutation((body: any) => addItem(id!, body)),
      updateItemDiscount: wrapMutation((itemId: string, discount: number) =>
        updateItemDiscount(id!, itemId, discount)
      ),
      updateItemQuantity: wrapMutation((itemId: string, quantity: number) =>
        updateItemQuantity(id!, itemId, quantity)
      ),
      removeItem: wrapMutation((itemId: string) => removeItem(id!, itemId)),
      addCoupon: wrapMutation((code: string) => addCoupon(id!, code)),
      removeCoupon: wrapMutation(() => removeCoupon(id!)),
    },
  }
}
